/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import {clamp} from '@benchling/js-utils';
import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import InsertTableConstants from 'notebook/plain-tables/InsertTableConstants';
import * as TableConstants from 'notebook/tables/TableConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import withDropdownCloseControl, {DropdownCloseControlProps} from 'ui-library/menus/withDropdownCloseControl';
import {ElementMouseEvent} from 'util/Types';

const {DEFAULT_TABLE_SIZE} = TableConstants;
const {CELL_SIZE, CELL_PADDING, MAX_ROWS, MAX_COLS} = InsertTableConstants;

export interface InsertTableComponentProps extends DropdownCloseControlProps {
  insertTableWithDimensions: (rows: number, cols: number) => void;
}

export interface InsertTableComponentState {
  numRows: number;
  numCols: number;
}

// Keep Props/State aliases for internal use
type Props = InsertTableComponentProps;
type State = InsertTableComponentState;

class InsertTableComponent extends React.Component<Props, State> {
  override state: State = {
    numRows: DEFAULT_TABLE_SIZE[0],
    numCols: DEFAULT_TABLE_SIZE[1],
  };

  cellGridRef = React.createRef<HTMLDivElement>();

  insertTable = (e: ElementMouseEvent): void => {
    e?.stopPropagation();
    this.props.insertTableWithDimensions(this.state.numRows, this.state.numCols);
    this.props._onCloseDropdown?.();
  };

  setDimensions = (numRows: any, numCols: any): void => {
    this.setState({
      numRows: clamp(1, MAX_ROWS, numRows),
      numCols: clamp(1, MAX_COLS, numCols),
    });
  };

  mouseMoveHandler = (e: any): void => {
    const {top, left} = $(ReactDOM.findDOMNode(this.cellGridRef.current)!).offset()!;
    const mouseOffsetX = e.pageX - Math.round(left);
    const mouseOffsetY = e.pageY - Math.round(top);

    const numRows = Math.ceil(mouseOffsetY / (CELL_SIZE + 2 * CELL_PADDING));
    const numCols = Math.ceil(mouseOffsetX / (CELL_SIZE + 2 * CELL_PADDING));
    this.setDimensions(numRows, numCols);
  };

  renderCell = (row: any, col: any): JSX.Element => (
    <span
      key={col}
      className={classNames('insertTable-cell', {
        'is-highlighted': row < this.state.numRows && col < this.state.numCols,
      })}
      style={{
        height: CELL_SIZE,
        width: CELL_SIZE,
        margin: CELL_PADDING,
      }}
      {...getTestProps({component: 'InsertTableComponent', element: 'cell', key: `${row}-${col}`})}
    />
  );

  renderRow = (row: any): JSX.Element => {
    const numColsToRender = clamp(5, MAX_COLS, this.state.numCols + 1);
    return (
      <div
        key={row}
        className="insertTable-row"
        {...getTestProps({component: 'InsertTableComponent', element: 'row', index: `${row}`})}
      >
        {__range__(0, numColsToRender, false).map((col) => this.renderCell(row, col))}
      </div>
    );
  };

  renderGrid = (): JSX.Element => {
    const numRowsToRender = clamp(5, MAX_ROWS, this.state.numRows + 1);
    return (
      <div className="insertTable-visibleCells" onMouseMove={this.mouseMoveHandler}>
        <div
          className="insertTable-dimensionCaption text-center"
          {...getTestProps({component: 'InsertTableComponent', element: 'dimensionCaption'})}
        >
          {`${this.state.numRows} x ${this.state.numCols}`}
        </div>
        <div
          ref={this.cellGridRef}
          onClick={this.insertTable}
          {...getTestProps({component: 'InsertTableComponent', element: 'cellGrid'})}
        >
          {__range__(0, numRowsToRender, false).map((row) => this.renderRow(row))}
        </div>
      </div>
    );
  };

  // The mouseTracker div has a onMouseMove handler that calculates how many rows / cols to display
  // The entire mouse-catcher div is the max size of the renderable grid, plus buffer room (when the
  // so the user can mouse away from the grid and it won't immediately disappear).
  override render(): JSX.Element {
    return (
      <div className="insertTable">
        <div
          className="insertTable-mouseTracker"
          onMouseMove={this.mouseMoveHandler}
          style={{
            width: MAX_COLS * (CELL_SIZE + 2 * CELL_PADDING) + 100,
            marginLeft: -50,
            marginTop: -50,
            height: MAX_ROWS * (CELL_SIZE + 2 * CELL_PADDING) + 100,
            position: 'absolute',
          }}
          {...getTestProps({component: 'InsertTableComponent', element: 'mouseTracker'})}
        />
        {this.renderGrid()}
      </div>
    );
  }
}

const InsertTableComponentWithDropdownCloseControl = withDropdownCloseControl(InsertTableComponent);
// Exporting the raw component for testing purposes
export {InsertTableComponent};

export default InsertTableComponentWithDropdownCloseControl;

function __range__(left: number, right: number, inclusive: boolean): Array<number> {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
